export const getShortcutValues = (accumulated: string[], current: string | object): string[] => {
	if (typeof current === 'string') {
		accumulated.push(current);
	} else if (typeof current === 'object') {
		accumulated.push(...Object.values(current).reduce(getShortcutValues, []));
	}
	return accumulated;
};
